import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { usePaymentStatus } from "@/hooks/usePaymentStatus";

const FAILED = { Icon: XCircle, iconCls: "text-[#FF0000]", text: "Please try again from your dashboard.", cta: "Back to Dashboard" };

const VIEWS = {
  polling: { Icon: Loader2, iconCls: "animate-spin text-[#0000EE]", title: "Verifying Payment…", text: "Hang tight, this only takes a moment." },
  paid: { Icon: CheckCircle2, iconCls: "text-[#008800]", title: "Payment Successful", text: "Your listing is now ★ FEATURED. It will appear at the top of search results.", cta: "Back to Dashboard →" },
  expired: { ...FAILED, title: "Session Expired" },
  timeout: { ...FAILED, title: "Status Unknown" },
};

const BUMPED = { ...VIEWS.paid, text: "Your ad has been bumped to the top and is live for another 30 days." };

export default function PromoteSuccess() {
  const [params] = useSearchParams();
  const { user, loading } = useAuth();
  const { status, kind } = usePaymentStatus(params.get("session_id"), !loading && Boolean(user));
  const view = status === "paid" && kind === "bump" ? BUMPED : VIEWS[status];
  const { Icon, iconCls, title, text, cta } = view;

  return (
    <div className="max-w-[600px] mx-auto px-4 md:px-8 mt-16" data-testid="promote-success-page">
      <div className="border-2 border-black bg-white p-8 hard-shadow text-center">
        <Icon className={`mx-auto mb-4 ${iconCls}`} size={52} />
        <h1 className="font-display text-3xl uppercase" data-testid="promote-status-title">{title}</h1>
        <p className="font-mono-data text-xs uppercase text-gray-600 mt-2">{text}</p>
        {cta && (
          <Link to="/dashboard" data-testid="back-to-dashboard" className="inline-block mt-6 bg-black text-white px-6 py-3 border-2 border-black font-mono-data text-xs uppercase hover:bg-[#0000EE] hover:border-[#0000EE] no-underline hover:no-underline">{cta}</Link>
        )}
      </div>
    </div>
  );
}
